import { getAppHost, getAppEndpointVersion } from 'helpers'
import axios from './axiosInstance'

// List the System Tools catalog (global, not agent-scoped)
// GET /ai-agents/agent-builder/agents/system-tools -> [{ slug, name, description }]
export const list = async (app, appSettings) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/system-tools`

    const response = await axios.get(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Enable system tool(s) on an agent
// PATCH /ai-agents/agent-builder/agents/:agentId/system-tools/add  body: { systemTools: [slug] }
export const add = async (app, appSettings, agentId, systemTools) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentId}/system-tools/add`

    const response = await axios.patch(baseURL, systemTools, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Disable system tool(s) on an agent
// PATCH /ai-agents/agent-builder/agents/:agentId/system-tools/remove  body: { systemTools: [slug] }
export const remove = async (app, appSettings, agentId, systemTools) => {
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/${agentId}/system-tools/remove`

    const response = await axios.patch(baseURL, systemTools, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}
